import { render, staticRenderFns } from "./satisfaction.vue?vue&type=template&id=661f2cc6&scoped=true&"
import script from "./satisfaction.vue?vue&type=script&lang=js&"
export * from "./satisfaction.vue?vue&type=script&lang=js&"
import style0 from "./satisfaction.vue?vue&type=style&index=0&id=661f2cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f2cc6",
  null
  
)

export default component.exports